export default {
  '组织结构列表':'Organizational Structure List',
  '请输入名称\代码':'Please enter the name or code',
  '管理成员':'Manage Members',
  '组织结构名称':'Organizational Structure Name',
  '上级组织':'Superior Organization',
  '组织代码':'Organization Code',
  '添加成员':'Add Members',
  '组织结构':'Organizational Structure',
  '组织结构代码需为两位':'The organizational structure code must be two digits',
  '新增组织结构':'Add New Organizational Structure',
  '编辑组织结构':'Edit Organizational Structure',
  '确认要删除该组织结构：{departmentName}？':'Are you sure you want to delete this organizational structure: {departmentName}?',
  '取消全部选中':'Cancel All Selections',
  '是否确认批量移除{selectedUser}名成员？':'Are you sure you want to batch remove {selectedUser} members?',
  '是否确认移除成员{accountName}？':'Are you sure you want to remove the member {accountName}?',

  '确认要删除该机构：{tenantOrgName}？':'Confirm to delete this organization: {tenantOrgName}?',  
  '确认要停用该机构：{tenantOrgName}？':'Confirm to disable this organization: {tenantOrgName}?',  
  '确认要启用该机构：{tenantOrgName}？':'Confirm to enable this organization: {tenantOrgName}?',  
  '停用该机构将会停用下层级机构':'Disabling this organization will disable the subordinate departments along with it',  
}    